import { SET, FETCH, FETCH_SUCCESS, SET_USER,SET_ALERT } from './actionTypes';

interface IAlert {
  alert:{
    open: boolean;
    severity: string;
    alertMessage:string;
  }
};

const defaultStore:IAlert = {
  alert:{
    open:false,
    severity:'success',
    alertMessage:'Mensaje exitoso'
  }
}

export default function user(
  state: IAlert = defaultStore,
  action: any,
) {
  switch (action.type) {

    case SET_ALERT:
      return {
        ...state,
        alert: action.payload
      }

    default:
      return state;
  }
}
